import { render, staticRenderFns } from "./LgFinderPageEspecificacaoProduto.vue?vue&type=template&id=6f83df73"
import script from "./LgFinderPageEspecificacaoProduto.vue?vue&type=script&lang=js"
export * from "./LgFinderPageEspecificacaoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports